//* *****************************************************************************************/
// SYSTEM NAME      : NetDial-TSP MODULE
//* *****************************************************************************************/

export default {
  LEVEL1: 1,
  LEVEL2: 2,
  LEVEL3: 3,
  LEVEL4: 4,
  LEVEL5: 5,
  LEVEL6: 6,
  LEVEL7: 7,

  FAIL: -1,
  TRUE: 1,
  FALSE: 0,

  BUF_64: 64,
  BUF_128: 128,
  BUF_512: 512,
  BUF_1024: 1024,
  BUF_2048: 2048,
  BUF_4096: 4096,
  BUF_8192: 8192,
  BUF_65536: 65536,

  //* BASIC data length definition */
  TEL_SIZE: 4 /* 전화번호 / ICD 번호 */,
  ICDNM_SIZE: 32 /* Group Name */,
  MAJOR_SIZE: 5 /* MAJOR CODE */,
  MINOR_SIZE: 5 /* MINOR CODE */,
  LOGIN_SIZE: 8 /* LOGIN ID SIZE */,
  AGTID_SIZE: 12 /* AGENT ID */,
  AGTNM_SIZE: 15 /* AGENT NAME */,
  IP_SIZE: 15 /* IP Address */,
  CAMPAIGNID_SIZE: 15 /* Campaign ID */,
  CAMPAIGNNM_SIZE: 30 /* Campaign Name */,
  JOBID_SIZE: 10,
  DATETIME_SIZE: 14 /* date and time yyyymmddhhmmss */,
  CUSTID_SIZE: 20 /* customer id */,
  CUSTKEY_SIZE: 5 /* customer key(i-Ray에서 생성) */,
  CUSTNM_SIZE: 20 /* customer 명 */,
  CUSTTEL_SIZE: 20 /* 고객 전화번호 */,
  SVCCODE_SIZE: 4 /* Service Code */,
  NODE_SIZE: 1 /* PBX Node Size */,
  SUBSTATUS_SIZE: 2 /* 상세 상태  */,
  SECTION_SIZE: 15 /* ini Section 자리수 */,
  KEYWORD_SIZE: 15 /* ini keyWord 자리수 */,
  INIDATA_SIZE: 10 /* ini Data 자리수 */,
  MEDIA_SIZE: 2 /* Medial 자리수 */,
  MSGDATA_COUNT: 30 /* Medial 자리수 */,
  UUI_SIZE: 128, // 128,  /* common UserInfo Size */

  /* CALL 상태 */
  CAL_STOP: 'S',
  CAL_INITIATED: 'I',
  CAL_ORIGINATED: 'O',
  CAL_DELIVERED: 'D',
  CAL_ESTABLISHED: 'E',
  CAL_CALLCLEARED: 'A',
  CAL_IDLE: 'W',
  CAL_HELD: 'H',
  CAL_RETRIEVED: 'R',
  CAL_TRANSFERRED: 'T',
  CAL_CONFERENCED: 'C',

  SYS_IVR: 'I',
  SYS_AGT: 'A',

  // enum
  ATTUUIProtocolType_t: {
    UUI_NONE: -1,
    UUI_USER_SPECIFIC: 0,
    UUI_IA5_ASCII: 4
  },

  ATTUserToUserInfo,
  P_API,
  P_DN,

  IS_CHANGE_STATUS: false
};

function ATTUserToUserInfo() {
  this.type = 0; // ATTUUIProtocolType_t
  this.data = new Data();
}

function Data() {
  this.length = 0; // short 2
  this.value = 0; // unsigned char[UUI_SIZE + 1] 257
}

function ND_MESSAGE() {
  this.This_dn = 0; // char[20]
  this.msgCode = 0; // unsigned int
  this.Message = 0; // char[408]
}

function ND_CSTAEVENT() {
  this.DNDFlag = 0; // UINT
  this.MSGFlag = 0; // UINT
  this.FWDFlag = 0; // UINT
  this.FWDType = 0; // UINT
  this.DEVType = 0; // UINT
  this.DEVClass = 0; // UINT
  this.AGTstate = 0; // UINT
  this.CallID = 0; // UINT
  this.priOldCallID = 0; // UINT
  this.secOldCallID = 0; // UINT
  this.localConnState = 0; // UINT
  this.eventCause = 0; // UINT
  this.numberQueued = 0; // UINT
  this.This_dn = 0; // char[20]
  this.FWD_dn = 0; // char[20]
  this.MSG_dn = 0; // char[20]
  this.AgentID = 0; // char[20]
  this.AgentGroup = 0; // char[10]
  this.Subject_dn = 0; // char[20]
  this.Calling_dn = 0; // char[20]
  this.Called_dn = 0; // char[20]
  this.Redirection_dn = 0; // char[20]
  this.Connection_dn1 = 0; // char[20]
  this.Connection_dn2 = 0; // char[20]
  this.Connection_dn3 = 0; // char[20]
  this.UserInfo = 0; // char[UUI_SIZE+1] 257
  this.AccountInfo = 0; // char[40]
  this.AuthCode = 0; // char[40]
  this.pData = 0; // char[40]
}

function ND_APIEVENT() {
  this.event = 0; // UINT
  this.u = new U();
}

function U() {
  this.m = new ND_MESSAGE();
  this.e = new ND_CSTAEVENT();
}

function P_API() {
  this.Event = new ND_APIEVENT();
  this.next = 0; // P_API
}

// typedef struct RECV_EVENT       *P_API;

function P_DN() {
  this.pre = 0; // P_DN
  this.dn = 0; // char[20]
  this.ErrMsg = 0; // char[BUF_512]
  this.next = 0; // P_DN
}

// typedef struct DN_INFO *P_DN;



// WEBPACK FOOTER //
// ./src/util/call/neomecca/netDialAPI/ndCommon.js